import {MIOBSPDialogActions} from "./MIOBSPDialogActions";
import {MIOBSPDialogState} from "./MIOBSPDialog";
import {PledgerAction} from "@pledger/frontend-commons";


export const miobspDialog = (state : MIOBSPDialogState = {isOpen : false} ,action : PledgerAction) => {

    let newState = state;

    switch (action.type) {
        case MIOBSPDialogActions.SHOW_MIOBSPDIALOG_ACTION.type:
            newState={ isOpen : true, ...action.payload };
        break;

        case MIOBSPDialogActions.CLOSE_MIOBSPDIALOG_ACTION.type:
            newState={isOpen : false};
        break;

        default:
            newState=state;
    }
    return newState;
 };

